'use client'
import { useState } from 'react';
import { motion } from 'framer-motion';
import s from './highlight.module.scss';
import ProjectFeaturedComponent from '@/components/singles/projectFeatured';
import { Status, Region, Typology } from '@/types/singles/category';
import { Image } from '@/types/common/ImageData';
import LazyImage from '@/components/common/LazyImage';
import Link from 'next/link';

interface HighlightProps {
    data: any;
}

export default function Highlight({ data }: HighlightProps) {

    return (
        <>
            <motion.div  
                className={s.hero}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
                viewport={{ once: true }}>
                {data.optionType == 'journal' && (
                    <Link href={`${data.journal.isExternal && data.journal.externalUrl ? data.journal.externalUrl : `/journal/${data.journal.slug}`}`} target={`${data.journal.isExternal && data.journal.externalUrl ? `_blank` : `_self`}`}>
                    <div className={s.heroImage}>
                        <div className={s.veil}></div>
                        {data.journal.featuredImage && data.journal.featuredImage.image &&
                            <LazyImage
                                src={data.journal.featuredImage.image.imageUrl}
                                width={data.journal.featuredImage.image.metadata.dimensions.width}
                                height={data.journal.featuredImage.image.metadata.dimensions.height}
                                blurDataURL={data.journal.featuredImage.image.ref}
                                fill={true}
                                alt={data.journal.featuredImage.image.attribution || ""}
                                caption={data.journal.featuredImage.image.caption || null}
                                filename={data.journal.featuredImage.image.filename || ""}
                            />
                        }
                    </div>
                    <div className={s.heroContent}>
                        <div className={s.heroText}>
                            <h1>{data.journal.title}{data.journal.secondTitle && <>: <br></br>{data.journal.secondTitle}</>}</h1>
                            <div>
                                {data.journal.subtitle && <p className={s.h1}>{data.journal.subtitle}</p>}
                                {data.journal.author && <p className={s.author}><span>Written By</span> <span>{data.journal.author}</span></p>}
                            </div>
                        </div>
                    </div>
                    </Link>
                )}
                {data.optionType == 'project' && (
                    <Link href={`/projects/${data.project.slug}`}>
                    <div className={s.heroImage}>
                        <div className={s.veil}></div>
                        {data.project.featuredImage && data.project.featuredImage.image &&
                            <LazyImage
                                src={data.project.featuredImage.image.imageUrl}
                                width={data.project.featuredImage.image.metadata.dimensions.width}
                                height={data.project.featuredImage.image.metadata.dimensions.height}
                                blurDataURL={data.project.featuredImage.image.ref}
                                fill={true}
                                alt={data.project.featuredImage.image.attribution || ""}
                                caption={data.project.featuredImage.image.caption || null}
                                filename={data.project.featuredImage.image.filename || ""}
                            />
                        }
                        <div className={s.content}>
                            <p>NEW PROJECT</p>
                            <h2>{data.project.title}</h2>
                            {data.project.location && <h3>{data.project.location}</h3>}
                        </div>
                    </div>
                </Link>
                )}
            </motion.div>
        </>
    );
}